<template>
  <SeoPage page-key="produzioneVideoAziendaliTicino" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'ProduzioneVideoAziendaliTicinoPage'
})
</script>

